import Container from './LandingContainer'
import { TbCircleCheck, TbClockHour4 } from 'react-icons/tb'
import { motion } from 'framer-motion'

type AvailableItem = {
    title: string
    description: string
}

const availableNow: AvailableItem[] = [
    {
        title: 'Personal notes workspace',
        description:
            'Capture raw thoughts, meeting notes, ideas, hypotheses, links, and working drafts.',
    },
    {
        title: 'Fast editing with autosave',
        description: 'Write quickly without thinking about manual saving.',
    },
    {
        title: 'Checklists inside notes',
        description:
            'Turn parts of your thinking into lightweight action lists without moving them into a task manager.',
    },
    {
        title: 'Encrypted secret fields',
        description:
            'Store sensitive snippets next to your working notes, hidden by default and encrypted client-side.',
    },
    {
        title: 'Note history',
        description: 'Keep previous versions as your notes evolve over time.',
    },
]

const stillEvolving: string[] = [
    'Advanced organization',
    'Search improvements',
    'Sharing and collaboration',
    'Mobile polish',
    'Import/export workflows',
]

const EarlyAccess = () => {
    return (
        <div id="earlyAccess" className="relative z-20 py-2.5 md:py-10">
            <Container>
                <motion.div
                    className="text-center mb-12"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, type: 'spring', bounce: 0.1 }}
                    viewport={{ once: true }}
                >
                    <motion.h2 className="my-6 text-5xl">
                        What you can use today
                    </motion.h2>
                    <motion.p className="mx-auto max-w-[600px]">
                        MemoSlate is open for early use with the core workflow
                        already available.
                    </motion.p>
                </motion.div>

                <div className="grid lg:grid-cols-2 gap-6 mt-12">
                    <motion.div
                        className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-6 lg:p-8"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            type: 'spring',
                            bounce: 0.1,
                        }}
                        viewport={{ once: true }}
                    >
                        <h3 className="text-2xl font-semibold mb-6">
                            Available now
                        </h3>
                        <div className="flex flex-col gap-5">
                            {availableNow.map((item) => (
                                <div key={item.title} className="flex gap-3">
                                    <TbCircleCheck className="text-xl mt-1 text-primary flex-shrink-0" />
                                    <div>
                                        <p className="font-medium">
                                            {item.title}
                                        </p>
                                        <p className="text-sm text-muted dark:text-muted-dark mt-1">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>

                    <motion.div
                        className="bg-gray-100 dark:bg-gray-800 rounded-3xl p-6 lg:p-8"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.3,
                            type: 'spring',
                            bounce: 0.1,
                            delay: 0.1,
                        }}
                        viewport={{ once: true }}
                    >
                        <h3 className="text-2xl font-semibold mb-6">
                            Still evolving
                        </h3>
                        <div className="flex flex-col gap-4">
                            {stillEvolving.map((item) => (
                                <div key={item} className="flex items-center gap-3">
                                    <TbClockHour4 className="text-xl text-muted dark:text-muted-dark flex-shrink-0" />
                                    <span className="text-sm">{item}</span>
                                </div>
                            ))}
                        </div>
                        <p className="text-xs text-muted dark:text-muted-dark mt-8">
                            The product is useful now, but still early. We're
                            actively shaping these areas based on real usage.
                        </p>
                    </motion.div>
                </div>
            </Container>
        </div>
    )
}

export default EarlyAccess

